import { useEffect } from "react"

export function isInIframe() {
  try {
    return window.self !== window.top
  } catch (e) {
    return true
  }
}

export function useIframeSizer() {
  useEffect(() => {
    if (!isInIframe()) return
    const handleResize = () => {
      const height = document.getElementsByTagName("body")[0].offsetHeight
      window.parent.window.postMessage(`software.reflexive.embed.height:${height}`, "*")
    }
    window.addEventListener("resize", handleResize)
    handleResize()
    const handleMessage = (e: MessageEvent) => {

    }
    window.addEventListener("message", handleMessage)
    return () => {
      window.removeEventListener("resize", handleResize)
      window.removeEventListener("message", handleMessage)
    }

  }, [])
}